import styled from 'styled-components';

import colors from 'styles/colors';
import FlexDiv from 'components/FlexDiv';

export const Container = styled.div`
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding: 48px 24px;
`;

export const ModalContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 900px;
  background-color: ${colors.white};
  box-shadow: 0 0 64px 0 ${colors.gray_shadow_03};
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled(FlexDiv)`
  padding: 16px 24px;
  border-bottom: 1px solid ${colors.gray_scale4};
  gap: 8px;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.black};
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TabBar = styled.div`
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid ${colors.gray_scale4};
  background-color: ${colors.white};
  scrollbar-width: thin;
`;

export const TabItem = styled.button<{ active: boolean }>`
  flex-shrink: 0;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: ${({ active }) => (active ? '600' : '400')};
  color: ${({ active }) => (active ? colors.brand_2 : colors.black)};
  background: none;
  border: none;
  border-bottom: 2px solid ${({ active }) => (active ? colors.brand_2 : 'transparent')};
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: ${colors.brand_2};
  }
`;

export const PreviewArea = styled.div`
  position: relative;
  padding: 24px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 600px;
  object-fit: contain;
`;

export const PreviewIframe = styled.iframe`
  width: 100%;
  height: 600px;
  border: none;
`;

export const PreviewVideo = styled.video`
  max-width: 100%;
  max-height: 500px;
`;

export const PreviewText = styled.pre`
  width: 100%;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13px;
  line-height: 1.6;
  color: ${colors.black};
  background-color: ${colors.gray_scale5};
  padding: 16px;
  border-radius: 4px;
  max-height: 500px;
  overflow-y: auto;
`;

export const PreviewUnavailable = styled.div`
  text-align: center;
  color: ${colors.gray_scale2};

  p {
    margin: 12px 0 20px;
    font-size: 14px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid ${colors.gray_scale4};
`;

export const FooterCounter = styled.span`
  font-size: 13px;
  color: ${colors.gray_scale2};
  white-space: nowrap;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.white};
  z-index: 1;
`;

